import webuiState from "../app/InternalStateService";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
import { getUiStatePaths } from "../utils/storeUtils";

export function triggerApplicationLoading(triggerFlag = true) {
    if (triggerFlag) {
        WEBUILogs.log("trigger application loading");
        return {
            type: "TRIGGER_APPLICATION_LOADING"
        };
    } else {
        WEBUILogs.log("dismiss application loading");
        return {
            type: "DISMISS_APPLICATION_LOADING"
        };
    }
}

export function triggerGlobalLoading(triggerFlag = true) {
    if (triggerFlag) {
        WEBUILogs.log("triggerGlobalLoading");
        return {
            type: "TRIGGER_GLOBAL_LOADING"
        };
    } else {
        WEBUILogs.log("dissmissGlobalLoading");
        return {
            type: "DISMISS_GLOBAL_LOADING"
        };
    }
}

export function dismissGlobalLoading() {
    return triggerGlobalLoading(false);
}

export function triggerMainAreaLoading(triggerFlag = true) {
    if (triggerFlag) {
        return {
            type: "TRIGGER_MAIN_AREA_LOADING"
        };
    } else {
        return {
            type: "DISMISS_MAIN_AREA_LOADING"
        };
    }
}

export function dismissMainAreaLoading() {
    return triggerMainAreaLoading(false);
}

//triggers loading animation for entity
//adds "hideLoading" action as final action if none is added already
export function showLoadingSirenAction(sirenAction, widgetId, path) {
    let finalActions = sirenAction.finalActions || [];
    let missingHideLoadingAction = true;
    //check if finalActions have "hideLoading" action
    finalActions.forEach(action => {
        if (action.actionType === "hideLoading") {
            missingHideLoadingAction = false;
        }
    });
    if (missingHideLoadingAction) {
        finalActions.push({
            actionType: "hideLoading",
            dependencies: sirenAction.dependencies
        });
    }
    //in case of missing finalActions
    sirenAction.finalActions = finalActions;
    return triggerLoading(sirenAction.dependencies, path, true, widgetId);
}

export function hideLoadingSirenAction(sirenAction, widgetId, path) {
    return triggerLoading(sirenAction.dependencies, path, false, widgetId);
}

//general purpose method for triggering loading uiState property change for entities
export function triggerLoading(dependencies = [], path, triggerFlag, widgetId) {
    const triggerMultipleSetUiState = webuiState.getActionByName(
        "component.triggerMultipleSetUiState"
    );
    return (dispatch, getState) => {
        let uiStatePaths;
        let entityChanges;
        if (!dependencies.length) {
            return Promise.reject("Action failed: missing dependecies.");
        }

        uiStatePaths = getUiStatePaths(dependencies, getState(), path, widgetId);
        if (!uiStatePaths.length) {
            return Promise.reject("Action failed: no correct dependencies found.");
        }
        entityChanges = uiStatePaths.map(uiStatePath =>
            dispatch(createTriggerLoadingActionData(uiStatePath, triggerFlag))
        );
        return dispatch(triggerMultipleSetUiState(entityChanges));
    };
}

export function triggerWidgetLoading(widgetId, triggerFlag) {
    const triggerMultipleSetUiState = webuiState.getActionByName(
        "component.triggerMultipleSetUiState"
    );
    return dispatch => {
        const actionData = dispatch(
            createTriggerLoadingActionData([widgetId, widgetId], triggerFlag)
        );
        return dispatch(triggerMultipleSetUiState([actionData]));
    };
}

//creates loading animation action data
//path and loading counter
function createTriggerLoadingActionData(uiStatePath, triggerFlag) {
    return (dispatch, getState) => {
        let loadingCounter = getState().getIn(["uiState", ...uiStatePath, "loading"]) || 0;
        let newLoadingCounter = loadingCounter + (triggerFlag ? 1 : -1);
        newLoadingCounter = newLoadingCounter < 0 ? 0 : newLoadingCounter;
        return {
            path: uiStatePath,
            state: {
                loading: newLoadingCounter
            }
        };
    };
}

export function wait(sirenAction) {
    let delay = sirenAction.delay || 3000;
    return dispatch =>
        new Promise((resolve, reject) => {
            setTimeout(() => {
                if (sirenAction.fail) {
                    reject("Action failed.");
                } else resolve("Action resolved.");
            }, delay);
        });
}

//general purpose action for triggering loading animation
export function triggerLoadingSiren(sirenAction, widgetId, path) {
    let actions = sirenAction.actions || [];
    let filteredActions = actions.filter(action => {
        return action.actionType === "dismissLoading";
    });

    if (!filteredActions.length) {
        actions.push({
            actionType: "dismissLoading",
            targets: sirenAction.targets,
            events: ["final"]
        });
    }
    //in case of missing finalActions
    sirenAction.actions = actions;
    return dispatch => {
        //manage targets - oneOf(["{root}", "{widget}", "{self}", "path"])
        let targets = sirenAction.targets || [];
        let loadingTargets = targets;
        if (targets.length === 1 && targets[0] === "{root}") {
            return dispatch(webuiState.getActionByName("loading.triggerGlobalLoading")(true));
        }
        if (targets.length === 1 && targets[0] === "{widget}") {
            loadingTargets = [widgetId];
        }
        if (targets.length === 1 && targets[0] === "{self}") {
            loadingTargets = [path];
        }
        return dispatch(triggerLoading(loadingTargets, path, true, widgetId));
    };
}

export function dismissLoadingSiren(sirenAction, widgetId, path) {
    let targets = sirenAction.targets || [];
    let loadingTargets = targets;
    return dispatch => {
        if (targets.length === 1 && targets[0] === "{root}") {
            return dispatch(webuiState.getActionByName("loading.triggerGlobalLoading")(false));
        }
        if (targets.length === 1 && targets[0] === "{widget}") {
            loadingTargets = [widgetId];
        }
        if (targets.length === 1 && targets[0] === "{self}") {
            loadingTargets = [path];
        }
        return dispatch(triggerLoading(loadingTargets, path, false, widgetId));
    };
}
